import { get, getWithoutToken, urlApiTegra  } from "../../../service/api";


function sendEmailValidate(email) {
  return getWithoutToken(`${urlApiTegra}/register/send_new_email/${email}` )
}

function validateHash(hash) {
  return getWithoutToken(`${urlApiTegra}/register/email_validation/${hash}`)
}

export { sendEmailValidate, validateHash}